import React, { useState, useEffect } from "react";
import "./ShopifyIntegrationPage.css";
import axios from "axios";
const API_HOST =
  process.env.REACT_APP_API_URL ||
  "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net";

const ShopifyIntegrationPage = () => {
  const [storeData, setStoreData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companyId, setCompanyId] = useState("");

  // New states for add store form
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    shop_name: "",
    access_token: "",
    version: "2024-01",
  });
  const [addingStore, setAddingStore] = useState(false);
  const [addStoreError, setAddStoreError] = useState(null);

  // STEP 1: Jab page load ho tab company ID fetch karo
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        console.log("📱 LocalStorage se user data:", userData);

        if (userData.company_id) {
          const id = userData.company_id.toString();
          setCompanyId(id);
          console.log("✅ Auto-set company ID:", id);
        } else {
          console.warn("User data mein company_id nahi hai");
          setCompanyId("21");
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
        setCompanyId("21");
      }
    } else {
      console.warn("Koi user logged in nahi hai");
      setCompanyId("21");
    }
  }, []);

  // STEP 2: Jab company ID change ho tab data fetch karo
  useEffect(() => {
    if (companyId) {
      console.log("🔄 Fetching data for company ID:", companyId);
      fetchStoreData(companyId);
    }
  }, [companyId]);

  const fetchStoreData = async (id) => {
    if (!id) {
      setError("Company ID nahi mili");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setStoreData(null);
    setShowAddForm(false);

    try {
      const response = await axios.get(
        `${API_HOST}/api/v1/getShopifyStore/${id}`,
      );

      if (response.data.success) {
        setStoreData(response.data.data);
      } else {
        // Agar "No store found" type ka error hai, toh form show karo
        if (
          response.data.message?.includes("No Shopify store") ||
          response.data.message?.includes("not found") ||
          response.data.message?.includes("No store")
        ) {
          setStoreData(null); // Explicitly set to null
          setError(null); // Clear any previous errors
        } else {
          setError(response.data.message || "Store data fetch nahi ho saka");
        }
      }
    } catch (err) {
      console.error("API Error:", err);

      // Check if 404 error (store not found)
      if (err.response?.status === 404) {
        setStoreData(null);
        setError(null);
      } else {
        setError(
          err.response?.data?.message || "Server se connect nahi ho raha",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyIdChange = (e) => {
    setCompanyId(e.target.value);
  };

  const handleRefresh = () => {
    if (companyId) {
      fetchStoreData(companyId);
    }
  };

  // Add Store Form Functions
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddStoreSubmit = async (e) => {
    e.preventDefault();

    if (!formData.shop_name || !formData.access_token || !formData.version) {
      setAddStoreError("Please fill all fields");
      return;
    }

    setAddingStore(true);
    setAddStoreError(null);

    try {
      const storeDataToSend = {
        company_id: parseInt(companyId),
        shop_name: formData.shop_name,
        access_token: formData.access_token,
        version: formData.version,
      };

      console.log("Adding store with data:", storeDataToSend);

      // API call to add store
      const response = await axios.post(
        API_HOST + "/api/v1/addShopifyStore",
        storeDataToSend,
      );

      console.log("Add store response:", response.data);

      if (response.data.success) {
        // Success! Hide form and fetch updated data
        alert("✅ Store successfully connected!");
        setFormData({
          shop_name: "",
          access_token: "",
          version: "2024-01",
        });
        setShowAddForm(false);

        // Wait a bit and fetch the new store data
        setTimeout(() => {
          fetchStoreData(companyId);
        }, 1500);
      } else {
        setAddStoreError(response.data.error || "Store add nahi ho saka");
      }
    } catch (err) {
      console.error("Add store error:", err);
      setAddStoreError(
        err.response?.data?.error || "Server error. Please try again.",
      );
    } finally {
      setAddingStore(false);
    }
  };

  const toggleAddForm = () => {
    setShowAddForm(!showAddForm);
    setAddStoreError(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Debug
  useEffect(() => {
    console.log(
      "Current State - Company ID:",
      companyId,
      "Loading:",
      loading,
      "Store Data:",
      storeData,
    );
  }, [companyId, loading, storeData]);

  return (
    <div className="shopify-page">
      <div className="page-header">
        <h1 className="page-title">Shopify Store Integration</h1>

        <div className="controls">
          <div className="company-selector">
            <label>Company ID:</label>
            <input
              type="text"
              value={companyId}
              onChange={handleCompanyIdChange}
              placeholder="Auto-detecting..."
              disabled={!!localStorage.getItem("user")}
            />
            <button onClick={handleRefresh} className="refresh-btn">
              Refresh
            </button>
          </div>

          <div className="user-info-badge">
            {(() => {
              const userStr = localStorage.getItem("user");
              if (userStr) {
                try {
                  const user = JSON.parse(userStr);
                  return (
                    <span>
                      {user.name} | Company: {user.company_id || "Not set"}
                    </span>
                  );
                } catch (e) {
                  return <span> User data error</span>;
                }
              }
              return <span> Not logged in</span>;
            })()}
          </div>
        </div>
      </div>

      {loading && (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading Shopify store data for Company ID: {companyId}</p>
        </div>
      )}

      {error && (
        <div className="error-state">
          <div className="error-icon">❌</div>
          <h3>Error Loading Data</h3>
          <p>{error}</p>
          <p>Company ID: {companyId}</p>
          <button onClick={handleRefresh} className="retry-btn">
            Try Again
          </button>
        </div>
      )}

      {/* SHOW EXISTING STORE IF FOUND */}
      {!loading && !error && storeData && (
        <div className="store-dashboard">
          <div className={`status-banner ${storeData.api_status}`}>
            <span className="status-icon">
              {storeData.api_status === "connected" ? "" : ""}
            </span>
            <span className="status-text">
              Shopify Store: <strong>{storeData.shop_info?.name}</strong> •
              Status: <strong>{storeData.api_status.toUpperCase()}</strong> •
              Company ID: <strong>{companyId}</strong>
            </span>
          </div>

          <div className="single-store-card">
            <div className="card-header">
              <h3 className="card-title"> Store Overview</h3>
              <div className="store-status">
                <span className={`status-badge ${storeData.api_status}`}>
                  {storeData.api_status === "connected"
                    ? "Connected"
                    : "Disconnected"}
                </span>
                <span className="company-id-badge">
                  Company ID: {companyId}
                </span>
              </div>
            </div>

            <div className="card-body">
              <div className="info-section">
                <h4 className="section-title"> Basic Information</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <span className="info-label">Store Name:</span>
                    <span className="info-value">
                      {storeData.shop_info?.name}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Owner:</span>
                    <span className="info-value">
                      {storeData.shop_info?.shop_owner}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Email:</span>
                    <a
                      href={`mailto:${storeData.shop_info?.customer_email}`}
                      className="info-link"
                    >
                      {storeData.shop_info?.customer_email}
                    </a>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Phone:</span>
                    <a
                      href={`tel:${storeData.shop_info?.phone}`}
                      className="info-link"
                    >
                      {storeData.shop_info?.phone}
                    </a>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Created:</span>
                    <span className="info-value">
                      {formatDate(storeData.shop_info?.created_at)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Last Updated:</span>
                    <span className="info-value">
                      {formatDate(storeData.shop_info?.updated_at)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <h4 className="section-title"> Store URLs</h4>
                <div className="urls-grid">
                  <div className="url-item">
                    <span className="url-label">Storefront:</span>
                    <a
                      href={storeData.store_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="url-link"
                    >
                      {storeData.shop_info?.domain || storeData.store_url}
                    </a>
                  </div>

                  <div className="url-item">
                    <span className="url-label">Admin Panel:</span>
                    <a
                      href={storeData.admin_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="url-link"
                    >
                      {storeData.shop_name}.myshopify.com/admin
                    </a>
                  </div>

                  <div className="url-item">
                    <span className="url-label">MyShopify Domain:</span>
                    <span className="url-text">
                      {storeData.shop_info?.myshopify_domain}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h3> Quick Actions</h3>
            <div className="action-buttons">
              <button
                className="action-btn primary"
                onClick={() => window.open(storeData.admin_url, "_blank")}
              >
                Open Shopify Admin
              </button>
              <button
                className="action-btn secondary"
                onClick={() => window.open(storeData.store_url, "_blank")}
              >
                View Store
              </button>
              <button className="action-btn" onClick={handleRefresh}>
                Refresh Data
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SHOW ADD STORE FORM WHEN NO STORE FOUND */}
      {!loading && !error && !storeData && (
        <div className="empty-state">
          <div className="empty-icon"></div>
          <h3>No Shopify Store Connected</h3>
          <p>
            No Shopify store found for <strong>Company ID: {companyId}</strong>
          </p>
          <p className="instruction-text">
            Connect your Shopify store using the form below:
          </p>

          <button onClick={toggleAddForm} className="connect-btn">
            {showAddForm ? "Cancel" : "Connect Shopify Store"}
          </button>

          {/* ADD STORE FORM - Auto shows when no store found */}
          {showAddForm && (
            <div className="add-store-form">
              <h4>🔗 Connect Your Shopify Store</h4>
              <p className="form-subtitle">
                Store will be linked to <strong>Company ID: {companyId}</strong>
              </p>

              <form onSubmit={handleAddStoreSubmit}>
                <div className="form-group">
                  <label>Shop Domain *</label>
                  <input
                    type="text"
                    name="shop_name"
                    value={formData.shop_name}
                    onChange={handleFormChange}
                    placeholder="yourstore.myshopify.com"
                    required
                  />
                  <small>
                    Your Shopify store URL without "https://" (e.g.,
                    mystore.myshopify.com)
                  </small>
                </div>

                <div className="form-group">
                  <label>Admin API Access Token *</label>
                  <input
                    type="password"
                    name="access_token"
                    value={formData.access_token}
                    onChange={handleFormChange}
                    placeholder="shpat_xxxxxxxxxxxxxxxxxxxxxx"
                    required
                  />
                  <small>
                    Get from: Shopify Admin → Settings → Apps and sales channels
                    → Develop apps → Your app → API credentials
                  </small>
                </div>

                <div className="form-group">
                  <label>API Version *</label>
                  <select
                    name="version"
                    value={formData.version}
                    onChange={handleFormChange}
                    required
                  >
                    <option value="2024-01">2024-01 (Latest)</option>
                    <option value="2023-10">2023-10</option>
                    <option value="2023-07">2023-07</option>
                    <option value="2023-04">2023-04</option>
                  </select>
                  <small>Shopify API version. Use latest if unsure.</small>
                </div>

                <div className="company-id-display">
                  <div className="id-badge">
                    <span className="badge-label">Company ID:</span>
                    <span className="badge-value">{companyId}</span>
                  </div>
                  <small>
                    This store will be permanently linked to this company
                  </small>
                </div>

                {addStoreError && (
                  <div className="form-error">❌ {addStoreError}</div>
                )}

                <div className="form-buttons">
                  <button
                    type="button"
                    onClick={toggleAddForm}
                    className="cancel-btn"
                    disabled={addingStore}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={addingStore}
                  >
                    {addingStore ? (
                      <>
                        <span className="spinner-small"></span> Connecting...
                      </>
                    ) : (
                      "Connect Store"
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ShopifyIntegrationPage;
